export const projectKeyParam = 'projectKey';
export const patternKeyParam = 'patternId';
export const variableKeyParam = 'variableKey';
export const reportClassParam = 'reportClass';
